import { useMutation, useQuery } from '@tanstack/react-query';
import api from '@api/http/api';

type ComplexUser = {
  premiumUntil?: string;
  complexBest: number;
  username: string;
  id: string;
};

export function useSearchPlayersMutation() {
  return useMutation<{ username: string; id: string; }[], {}, { name: string }>({
    mutationFn: (values) => api.post('/lobby/search', values),
  });
}

export function useSetPlanetMutation() {
  return useMutation<{ success: true }, {}, { mission?: number; planet: string; }>({
    mutationFn: (values) => api.post('/lobby/planet', values),
  });
}

export function useComplexLeaderboardQuery() {
  return useQuery<ComplexUser[]>({
    queryFn: () => api.get('/lobby/complex-leaderboard'),
    queryKey: ['complexLeaderboard'],
  });
}

export function useInvitePlayerMutation() {
  return useMutation<{ success: boolean }, {}, { id: string }>({
    mutationFn: (values) => api.post('/lobby/invite', values),
  });
}

export function useDeclineInviteMutation() {
  return useMutation<{ success: true }, {}, { id: string }>({
    mutationFn: (values) => api.post('/lobby/decline', values),
  });
}

export function useAcceptInviteMutation() {
  return useMutation<{ success: true }, {}, { id: string }>({
    mutationFn: (values) => api.post('/lobby/accept', values),
  });
}

export function useChangeLobbyTypeMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/lobby/change-type'),
  });
}

export function useLeaveLobbyMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/lobby/leave'),
  });
}

export function useStartGameMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/lobby/start'),
  });
}